/* eslint-disable prettier/prettier */
import { Checkbox, CheckboxIcon, CheckboxIndicator, CheckIcon, CircleIcon, Pressable, Radio, RadioGroup, RadioIcon, RadioIndicator, Text, View } from '@gluestack-ui/themed'
import _ from 'lodash'
import React, { PureComponent } from 'react'
import { StyleSheet } from 'react-native'
import { FormSelect } from '../../../api/Form/types'
import { ThemeState } from '../../../redux/theme/types'
import { theme } from '../../../theme'
import { LabelInput } from '../components'
import { FormElementProps } from '../types'

type CheckboxProps = FormElementProps<FormSelect, number[] | number | null> & ThemeState

class CheckboxFieldClass extends PureComponent<CheckboxProps> {
  public focus = () => {}

  public render() {
    const { field } = this.props
    switch (field.type) {
      case 'field_radio':
        return this.displayRadioButtons()
      case 'field_checkboxes':
        return this.displayCheckboxes()
      default:
        return null
    }
  }

  private displayCheckboxes() {
    const { field, value, setFieldValue } = this.props

    if (!value) {
      setFieldValue(this.elementId, [])
    }
    const valueArray = (value as Array<number | undefined> | null) || []
    const color = this.props.toolbarDefaultBg || theme.colors.silver

    return (
      <View>
        <LabelInput text={field.libelle} required={field.constraint.mandatory} />
        {field.items &&
          field.items.map(item => (
            <Pressable key={item.id} onPress={() => this.toggleValue(item.id)} style={styles.listItem}>
              <Text style={styles.itemText}>{item.libelle}</Text>
              <Checkbox value={item.id?.toString() as string} isChecked={valueArray.includes(item.id)} onChange={() => this.toggleValue(item.id)}>
                <CheckboxIndicator style={{ borderColor: color }}>
                  <CheckboxIcon as={CheckIcon} color={theme.colors.white} />
                </CheckboxIndicator>
              </Checkbox>
            </Pressable>
          ))}
      </View>
    )
  }

  private displayRadioButtons() {
    const { field, value, setFieldValue } = this.props

    if (!value) {
      setFieldValue(this.elementId, field.constraint.mandatory ? (_.first(field.items)?.id || '0').toString() : null)
    }

    const valueNumber = value
    const color = this.props.toolbarDefaultBg || theme.colors.silver

    return (
      <View>
        <LabelInput text={field.libelle} required={field.constraint.mandatory} />
        <RadioGroup value={(valueNumber || '0').toString() as string} onChange={item => this.toggleValue(+item)}>
          {field.items &&
            field.items.map(item => (
              <Pressable key={item.id} onPress={() => this.toggleValue(item.id)} style={styles.listItem}>
                <Text style={styles.itemText}>{item.libelle}</Text>
                <Radio value={item.id?.toString() as string}>
                  <RadioIndicator>
                    <RadioIcon as={CircleIcon} color={color} />
                  </RadioIndicator>
                </Radio>
              </Pressable>
            ))}
        </RadioGroup>
      </View>
    )
  }

  private toggleValue(id?: number) {
    const { field, value, setFieldValue } = this.props

    switch (field.type) {
      case 'field_checkboxes': {
        if (!value) {
          setFieldValue(this.elementId, [])
        }
        const valueArray = (value as Array<number | undefined> | null) || []
        if (valueArray.includes(id)) {
          const newValue = valueArray.filter(elementId => elementId !== id)
          setFieldValue(this.elementId, newValue)
        } else {
          setFieldValue(this.elementId, [...valueArray, id])
        }
        break
      }
      case 'field_radio': {
        if (value === id) {
          setFieldValue(this.elementId, null)
        } else {
          setFieldValue(this.elementId, id)
        }
        break
      }
      default:
        break
    }
  }

  private get elementId() {
    const { field } = this.props
    return `${field.id}`
  }
}

const styles = StyleSheet.create({
  listItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: theme.padding.x2,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.paleGrey,
  },
  itemText: {
    flex: 1,
  },
})

export { CheckboxFieldClass }
